// NOTE: Required by has-hover
import { HydratedRouter } from "react-router/dom";
import * as Sentry from "@sentry/react-router";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

window.global ||= window;

if (ENV?.SENTRY_DSN?.includes("sentry.io")) {
  import("~/lib/monitoring.client.tsx").then(({ init }) => {
    init();
    Sentry.setUser(window.user);
  });
}

// NOTE: See React docs. Strict mode results in components rendering and useEffect firing 2x.
// TODO: Re-evaluate disabling StrictMode when we're further along
const USE_STRICT_MODE = false;

const HTML = () =>
  USE_STRICT_MODE ? (
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  ) : (
    <HydratedRouter />
  );

startTransition(() => {
  hydrateRoot(document, <HTML />);
});
